module.exports = __webpack_public_path__ + "img/dispozicia_podielom.c4b78875.svg";